import _toKebabCase from 'lodash/kebabCase';
import indentContent from './indentContent';

type XmlSectionParams = {
  tagName: string;
  content: string | null | undefined;
  inline?: boolean;
  tagAttributes?: Record<string, string>;
};

function xmlSection({
  tagName,
  content,
  tagAttributes = {},
  inline = false,
}: XmlSectionParams): string {
  if (!content?.trim()) {
    return '';
  }

  // Only normalize if needed — kebabCase collapses double hyphens, which breaks callers that rely on them (e.g. 'plan-execution--reflection-phase')
  const normalizedTagName = /[A-Z_]/.test(tagName) ? _toKebabCase(tagName) : tagName;
  const tagAttributesString = _formatTagAttributes(tagAttributes);

  const openingTag = `<${normalizedTagName}${tagAttributesString ? ` ${tagAttributesString}` : ''}>`;
  const closingTag = `</${normalizedTagName}>`;

  if (inline) {
    return `${openingTag}${content}${closingTag}`;
  }

  return `${openingTag}
${indentContent(content)}
${closingTag}`;
}

function _formatTagAttributes(tagAttributes: Record<string, string>): string {
  return Object.entries(tagAttributes)
    .map(([key, value]) => `${key}="${value}"`)
    .join(' ');
}

export default xmlSection;
